import { Flex, Image, Box, Text, useToast, Skeleton, Heading, Button, Progress } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import { useMutation } from 'react-query';
import { getAssessmentReport, startAssessmentBlockItem } from '../../../apis/V2/assessment';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { UIErrorResponse } from '../../../../../../packages/types/src/error';
import { useUserProfile } from '../../../hooks/useUser';
import Lottie from 'react-lottie-player';
import successLottie from '../../assets/lottie/successLottie.json';
import ModalTemplateV2 from '../../common/ModalTemplateV2';
import { useAssessmentSubmissionBlockItem } from '../../../hooks/V2/useAssessmentSumbission';
import { MAX_ATTEMPTS, POLL_INTERVAL } from '../DashboardSteps/KnowYourLevelCard';
import ModalTemplate from '../../common/ModalTemplate';
import ShowPracticeTestModal from '../../common/ShowPracticeTestModal';
import ActiveBadgeModal from '../Badges/ActiveBadgeModal';
import { useAllBadges } from '../../../hooks/V2/useUser';
import ShareModal from '../../common/V2/SocialMedia/ShareModal';
import ShowBadgeLockedModal from '../../common/ShowBadgeLockedModal';
const BadgeAssessmentCard = ({ blockItem, meta, setShowComingSoonModal }: any) => {
	const { isKnowYourLevelAssessmentGiven, assessmentToken, setAssessmentToken, setRedirectionPath } = useAssessmentToken();
	const [isOpen, setIsOpen] = useState(false);
	const onClose = () => setIsOpen(false);
	const navigate = useNavigate();
	const toast = useToast();
	const {
		data: userAssessment,
		status,
		refetch: refetchUserAssessment,
		isLoading: loadingUserAssessment,
	} = useAssessmentSubmissionBlockItem(blockItem?._id || '');

	useEffect(() => {
		refetchUserAssessment();
	}, []);
	const { mutate: startAssessmentMutate, isLoading: startAssessmentLoading } = useMutation(startAssessmentBlockItem, {
		onSuccess: response => {
			setAssessmentToken(response.data.userAssessment.token);
			// redirect to assessment page
			setRedirectionPath(window.location.pathname + window.location.search);
			navigate(`/dashboard/block-item/${blockItem?._id}/assessment/start`);
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			console.log('error:', error);
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Unable to start assessment, please try again!',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});
	const { data: userProfile, refetch: refetchUserProfile } = useUserProfile();
	const [badgeAssessmentStatus, setBadgeAssessmentStatus] = React.useState<'NOT_STARTED' | 'PENDING' | 'PROGRESS' | 'FAILED' | 'PASSED'>(
		'NOT_STARTED',
	);
	useEffect(() => {
		// if user earned the badge
		if (badgeAssessmentStatus === 'PASSED') {
			// if we havent show the modal yet
			if (localStorage.getItem(`badgeCongratsModal-${blockItem?.assessment?.badgeId}-user-${userProfile._id}`) !== 'true') {
				setShowBadgeCongratsModal(true);
			} else {
				setShowBadgeCongratsModal(false);
			}
		}
	}, [badgeAssessmentStatus, blockItem?.assessment?.badgeId, userProfile._id, userProfile.badges]);

	const [assessmentStatus, setAssessmentStatus] = React.useState<string | undefined>(blockItem?.assessment?.userAssessment?.assessmentStatus);
	const [showWaitingModal, setShowWaitingModal] = useState(false);
	useEffect(() => {
		setAssessmentStatus(userAssessment?.assessmentStatus);
	}, [userAssessment?.assessmentStatus]);

	const [modalVisible, setModalVisible] = useState(false);
	React.useEffect(() => {
		console.log('assessmentStatus----:', assessmentStatus);
		if (assessmentStatus === 'COMPLETED') {
			setModalVisible(true);
			setShowWaitingModal(true);
		} else if (assessmentStatus === 'GRADED') {
			if (modalVisible) {
				setModalVisible(false);
				window.location.reload();
			}

			setShowWaitingModal(false);
		}
	}, [assessmentStatus, modalVisible, refetchUserProfile]);

	useEffect(() => {
		const userAssessment = blockItem?.assessment?.userAssessment;
		if (userAssessment) {
			const userBadgesIds = userProfile?.badges;
			const assessmentBadgeId = blockItem?.assessment?.badgeId;
			if (userBadgesIds && assessmentBadgeId) {
				console.log('assessmentStatus:--', assessmentStatus);
				if (userBadgesIds.includes(assessmentBadgeId)) {
					console.log('user has the badge', userBadgesIds, assessmentBadgeId);
					setBadgeAssessmentStatus('PASSED');
				} else {
					// assessment status is graded but user does not have the badge, mark as failed
					if (assessmentStatus === 'GRADED') {
						setTimeout(() => {
							refetchUserProfile();
						}, 2000);
						setBadgeAssessmentStatus('FAILED');
						// assessment status is started means user can continue to assessment
					} else if (assessmentStatus === 'STARTED' || assessmentStatus === 'PENDING' || !assessmentStatus) {
						setBadgeAssessmentStatus('PROGRESS');
					}
					// assessment status is COMPLETED but not graded, means user has submitted the assessment but not graded yet,
					else {
						setBadgeAssessmentStatus('PENDING');
					}
				}
			}
		} else {
			setBadgeAssessmentStatus('NOT_STARTED');
		}
	}, [assessmentStatus, blockItem?.assessment?.badgeId, blockItem?.assessment?.userAssessment, refetchUserProfile, userProfile?.badges]);

	const getbadgeStatusText = () => {
		if (blockItem && blockItem?._id) {
			switch (badgeAssessmentStatus) {
				case 'NOT_STARTED':
					return 'Take the quiz to earn the badge.';
				case 'PENDING':
					return `Please wait for the quiz to be graded!`;
				case 'PROGRESS':
					return 'Continue the quiz to earn the badge.';
				case 'FAILED':
					return 'Sorry! You are not eligible for the badge. ';
				case 'PASSED':
					return 'Congrats! You have received the badge.';
			}
		} else {
			return 'Ace the 1-1 Interview to earn this badge';
		}
	};

	const [pollInterval, setPollInterval] = useState<NodeJS.Timeout | null>(null); // State to store the interval reference
	const [attempts, setAttempts] = useState(0);

	const [showBadgeCongratsModal, setShowBadgeCongratsModal] = useState(false);

	// useEffect(() => {
	// 	if (localStorage.getItem(`badgeCongratsModal-${blockItem?._id}`) === 'true') {
	// 		return;
	// 	}
	// 	if (badgeAssessmentStatus === 'PASSED') {
	// 		setShowBadgeCongratsModal(true);
	// 		localStorage.setItem(`badgeCongratsModal-${blockItem?._id}`, 'true');
	// 	} else {
	// 		setShowBadgeCongratsModal(false);
	// 	}
	// }, [badgeAssessmentStatus, blockItem?._id, showBadgeCongratsModal]);

	useEffect(() => {
		if (!userAssessment) return;
		// Polling mechanism using setInterval
		const intervalId = setInterval(() => {
			// @ts-ignore
			setAttempts(prevAttempts => prevAttempts + 1);
			refetchUserAssessment(); // Manually trigger a refetch after each polling interval
		}, POLL_INTERVAL);

		setPollInterval(intervalId); // Store the interval reference in state

		// Clear interval when component unmounts or when desired result is obtained
		return () => {
			clearInterval(intervalId);
		};
	}, [refetchUserAssessment, userAssessment]);

	useEffect(() => {
		if (attempts > MAX_ATTEMPTS) {
			if (pollInterval) {
				clearInterval(pollInterval);
			}
			return;
		}

		if (attempts < MAX_ATTEMPTS && status === 'success') {
			// Check if the desired result is obtained, and if so, stop polling
			if (userAssessment && userAssessment.assessmentStatus === 'GRADED') {
				if (pollInterval) {
					clearInterval(pollInterval);
				}
			}
		}
	}, [attempts, userAssessment, status, pollInterval]);
	const { mutate: getAssessmentReportMutate, isLoading: getAssessmentReportLoading } = useMutation(getAssessmentReport, {
		onSuccess: data => {
			// console.log('Data:---------', data?.data?.reportUrl);
			// @ts-ignore
			const reportUrl = data?.data?.reportUrl;
			console.log('reportUrl:', reportUrl);
			// fetch report url
			if (reportUrl) {
				window.location.href = reportUrl || '';
			} else {
				toast({
					title: 'Error',
					description: "Submission token doesn't exist!",
					status: 'error',
					duration: 2000,
					isClosable: true,
					position: 'top',
				});
			}
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'Report failed',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	// dummy timer logic: NEED TO MAKE IT RESUSABLE

	const duration = 180;
	const [seconds, setSeconds] = useState(duration);
	const [showPracticeModal, setShowPracticeModal] = useState(false);
	const [showBadgeLockedModal, setShowBadgeLockedModal] = useState(false);
	useEffect(() => {
		// If the time is up, show a toast notification and clear the interval
		if (seconds === 0) {
			return;
		}

		// Set an interval to update the timer
		const interval = setInterval(() => {
			setSeconds(prevSeconds => prevSeconds - 1);
		}, 1000);

		// Clear interval on component unmount
		return () => clearInterval(interval);
	}, [seconds, toast]);

	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	// Convert minutes and seconds to strings and pad with 0 if necessary
	const formattedMinutes = minutes.toString().padStart(2, '0');
	const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
	const percent = (seconds / duration) * 100;

	const [badgeData, setBadgeData] = useState<any>(null);
	const { data: badges } = useAllBadges();
	useEffect(() => {
		if (!userProfile?.badges) return;

		if (userProfile?.badges.includes(blockItem?.assessment?.badgeId)) {
			// console.log('blockItem?.assessment?.badgeId:-----------', blockItem?.assessment?.badgeId, userProfile?.badges);
			const badgeId = blockItem?.assessment?.badgeId;
			// @ts-ignore
			const badgeData = badges?.find(badge => badge._id === badgeId);
			// console.log('badgeData:-----------', badgeData, blockItem?.assessment?.badgeId, userProfile?.badges);
			setBadgeData(badgeData);
		}
	}, [badges, blockItem?.assessment?.badgeId, userProfile?.badges]);

	return (
		<>
			<Skeleton minH="80px" roundedTop="7px" maxH={startAssessmentLoading ? '80px' : 'auto'} isLoaded={!startAssessmentLoading}>
				<Flex
					cursor="pointer"
					justifyContent={'space-between'}
					width={'100%'}
					alignItems={'center'}
					mt={5}
					gap={'1rem'}
					minH="80px"
					w={'100%'}
					bg={meta.bgColor}
					borderBottomLeftRadius={'7px'}
					borderBottomRightRadius={'7px'}
					borderTopLeftRadius={'16px'}
					borderTopRightRadius={'16px'}
					onClick={() => {
						if (isKnowYourLevelAssessmentGiven) {
							if (blockItem && blockItem?._id) {
								if (badgeAssessmentStatus === 'PASSED' || blockItem?.assessment?.userAssessment?.attemptsExceeded) {
									// getAssessmentReportMutate({ blockItemId: blockItem._id });
									// setShowBadgeCongratsModal(true);
								} else if (badgeAssessmentStatus === 'FAILED') {
									setShowBadgeLockedModal(true);
								} else {
									startAssessmentMutate({ blockItemId: blockItem?._id });
								}
							} else {
								setShowComingSoonModal(true);
							}
						} else {
							// TODO: show practice modal
							setShowPracticeModal(true);
						}
					}}
				>
					<Flex gap={'1rem'} justifyContent={'center'} alignItems={'center'}>
						<Box ml="12px" maxH="46px" maxW="46px" minH="46px" w="full">
							<Image w="full" src={meta?.blockBadgeIcon} alt="img" />
						</Box>
						<Text mb={2} textStyle={'body1-md'} color="#FFFFFF">
							{blockItem?.assessment?.userAssessment?.attemptsExceeded
								? 'Sorry! You did not clear the quiz and have not received the badge.'
								: getbadgeStatusText()}
						</Text>
					</Flex>
					{badgeAssessmentStatus === 'PASSED' ? (
						<Box w="64px" mx="auto" p={''}>
							<Lottie loop animationData={successLottie} play style={{ width: '100%' }} />
						</Box>
					) : badgeAssessmentStatus === 'FAILED' || blockItem?.assessment?.userAssessment?.attemptsExceeded ? (
						<Box pr="12px">
							<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="22.5" cy="22.5" r="21.3542" fill="white" stroke="#D6E2FA" stroke-width="1.70833" />
								<path
									d="M15.6664 22.4146H16.9477V21.1333V18.4C16.9477 16.9275 17.5326 15.5153 18.5739 14.4741C19.6151 13.4329 21.0273 12.8479 22.4998 12.8479C23.9723 12.8479 25.3845 13.4329 26.4257 14.4741C27.4669 15.5153 28.0519 16.9275 28.0519 18.4V21.1333V22.4146H29.3331C29.7182 22.4146 30.0876 22.5676 30.3599 22.8399C30.6322 23.1122 30.7852 23.4815 30.7852 23.8667V30.7C30.7852 31.0851 30.6322 31.4544 30.3599 31.7268C30.0876 31.9991 29.7182 32.1521 29.3331 32.1521H15.6664C15.2813 32.1521 14.912 31.9991 14.6397 31.7268C14.3673 31.4544 14.2144 31.0851 14.2144 30.7V23.8667C14.2144 23.4815 14.3673 23.1122 14.6397 22.8399C14.912 22.5676 15.2813 22.4146 15.6664 22.4146ZM26.5998 22.4146H27.881V21.1333V18.4C27.881 16.9728 27.3141 15.604 26.3049 14.5949C25.2957 13.5857 23.927 13.0187 22.4998 13.0187C21.0726 13.0187 19.7038 13.5857 18.6947 14.5949C17.6855 15.604 17.1185 16.9728 17.1185 18.4V21.1333V22.4146H18.3998H26.5998Z"
									fill="#544D4F"
									stroke="#544D4F"
									stroke-width="2.5625"
								/>
							</svg>
						</Box>
					) : (
						<Box p={'19px 12px 19px 0px'}>
							<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
								<path
									d="M5.3335 14.6667V17.3333H21.3335L14.0002 24.6667L15.8935 26.56L26.4535 16L15.8935 5.44L14.0002 7.33334L21.3335 14.6667H5.3335Z"
									fill="white"
								/>
							</svg>
						</Box>
					)}
				</Flex>
			</Skeleton>
			<ModalTemplateV2
				closeOnOverlayClick={false}
				isOpen={showWaitingModal}
				onClose={() => {
					setShowWaitingModal(false);
				}}
				showConfetti={false}
				hideIconWithConfetti={true}
				waiting={true}
				// autoCloseInSeconds={30}
				extra={
					<Box>
						{/* <Image w={{ base: '260px', md: '348px' }} h={{ base: '226px', md: '302px' }} mx="auto" src="/images/giff/waiting-gif.gif"></Image> */}
						<Heading as="h4" maxW="472px" color="#E5E5E5">
							Thank you for attempting!
						</Heading>

						<Text mt="8px" maxW="472px" color="#E5E5E5" textStyle={{ base: 'h6', md: 'h2' }}>
							Please wait while we are getting your scores.
						</Text>
						<Box my={4} px={4}>
							<Text color="#fff" fontSize="2xl">{`${formattedMinutes}:${formattedSeconds}`}</Text>
							<Progress borderRadius={'12px'} colorScheme="purple" mt="12px" size="lg" value={percent} />
						</Box>
						{/* <Button
							onClick={() => {
								refetchUserAssessment();
							}}
							variant="primary"
							mt="16px"
							bgColor={'#4358F6'}
						>
							Check Result Status
						</Button> */}
					</Box>
				}
			/>
			<ModalTemplate
				title=""
				marginX={2}
				paddingY="16px"
				isOpen={showPracticeModal}
				bgColor="white"
				maxWidth="343px"
				showCloseButton={true}
				showCloseButtonIcon={true}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => {
					setShowPracticeModal(false);
				}}
			>
				<ShowPracticeTestModal />
			</ModalTemplate>
			<ModalTemplate
				title=""
				marginX={2}
				paddingY="16px"
				isOpen={showBadgeLockedModal}
				bgColor="white"
				maxWidth="343px"
				showCloseButton={true}
				showCloseButtonIcon={true}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => {
					setShowBadgeLockedModal(false);
				}}
			>
				<ShowBadgeLockedModal setShowBadgeLockedModal={setShowBadgeLockedModal} />
			</ModalTemplate>
			<ModalTemplate
				title=""
				marginX={2}
				paddingY="0px"
				paddingX="0px"
				isOpen={showBadgeCongratsModal}
				bgColor="white"
				maxWidth="475px"
				showCloseButton={true}
				showCloseButtonIcon={true}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => {
					localStorage.setItem(`badgeCongratsModal-${blockItem?.assessment?.badgeId}-user-${userProfile._id}`, 'true');
					setShowBadgeCongratsModal(false);
				}}
			>
				<Box>
					<ActiveBadgeModal
						badgeTagLine={badgeData?.meta?.badgeTagLine}
						name={badgeData?.name}
						badgeIcon={badgeData?.meta?.badgeIcon}
						setIsOpen={setIsOpen}
					/>
				</Box>
			</ModalTemplate>
			<ShareModal title="Hurray! I have earned a new badge." shareUrl={badgeData?.meta?.badgeCard || ''} isOpen={isOpen} onClose={onClose} />
		</>
	);
};

export default BadgeAssessmentCard;
